import DriverAccounting from "../../../views/DriverAccounting";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const driverAccountingRoutes = [
  {
    menuName: MenuNames.DRIVER_ACCOUNTING,
    path: "/driver-accounting",
    component: DriverAccounting,
    exact: true,
  },
];

export default driverAccountingRoutes;
